import { useSelector } from 'react-redux';
import LayeredDashboardHeader from '../LayeredDashboardHeader';

const UseTemplate = ({ tab, setIsActive, setNotificationHeader, setNotificationDescription }) => {
  const myAppsData = useSelector(state => state.myAppsSlice.localReduxData);

  const app = myAppsData?.app;
  const data = [
    {
      m: 'Ocak',
      t: 'Yeni Yıl İhtiyaçlarınızı Alın ve Kutlayın! 🥳',
      d: '🎉 Heyecan Verici Fırsatlar Sizi Bekliyor! \n\nSeçili Ürünlerdeki Özel Tekliflerimizi Keşfedin. Sınırlı Süre! 💥',
      c: 'Yeni Yıl',
    },
    {
      m: 'Ocak',
      t: 'Tarzınızı Yükseltin!',
      d: "👓 Nova Gözlük + Göz Maskesi Paketi Sadece 199 TL. Kaçırmayın! 💃",
      c: 'Yeni Yıl',
    },
    {
      m: 'Ocak',
      t: '🔥Büyük İndirim Alarmı!🔥\n\nFavorilerde %55 İndirim',
      d: 'Tüm Favori Ürünlerinizde %55 İndirim Keyfini Çıkarın. Hemen Alışverişe Başlayın! 🛍️',
      c: 'Yeni Yıl',
    },
    {
      m: 'Ocak',
      t: "Yılbaşı İndirimi Başladı! %70'e Varan İndirimler!💃",
      d: "Yılbaşı İndirimi Başladı! İhtiyaç Duyduğunuz Ürünlerde %70'e Varan İndirimlerle Kutlayın! 🎉",
      c: 'Yeni Yıl',
    },
    {
      m: 'Ocak',
      t: 'Yeni Yılı Karşılayın🥂\n\n299 TL Üzeri Ücretsiz Kargo🎉',
      d: "Yeni Yılı Alışverişle Karşılayın! \n\n299 TL Üzeri Siparişlerde Ücretsiz Kargo. Kodu Kullanın: 'NEW22'. 🎊🛒",
      c: 'Yeni Yıl',
    },
    {
      m: 'Ocak',
      t: 'Sınırlı Süre Teklif⏳\n\nÜst Giyim Ürünlerinde Harika Fırsatlar🛍️',
      d: 'Yeni Yıla Hazırlanın: Üst Giyim, Alt Giyim ve Daha Fazlasında Harika Fırsatlar! 🎁',
      c: 'Yeni Yıl',
    },
    {
      m: 'Ocak',
      t: 'Yeni Koleksiyonumuzu Keşfedin: Hemen Alışveriş Yapın!🛍️',
      d: 'En Yeni Gelenlerle Mükemmel Tarzınızı Bulun. Hemen Alışveriş Yapın! 💃',
      c: 'Yeni Yıl',
    },
    {
      m: 'Ocak',
      t: 'Yılbaşı Partisine Hazır Olun🔥',
      d: "En Düşük Fiyatlar, En Büyük Koleksiyon ve Ücretsiz Kargo ile Yılbaşını Kutlayın🥂 \n\nKaçırmayın! 🎉🎁",
      c: 'Yeni Yıl',
    },
    {
      m: 'Ocak',
      t: 'Parlak Fırsatlarla Yeni Yılı Kutlayın!✨',
      d: "%60'a Varan İndirimler ve Ücretsiz Teslimat Keyfini Çıkarın.\n\nAceleyin, İndirim Yakında Sona Eriyor! 🎊⏳",
      c: 'Yeni Yıl',
    },
    {
      m: 'Ocak',
      t: 'Bugün Yüz Yıkama Jeli ile Sabun Alın! 🛍️',
      d: "Yüz Yıkama Jeli ile Sabun Alın ve %40'a Varan İndirim Kazanın. Kodu Kullanın 👉 MARTIN20. \n\nKendinize Bir Güzellik Yapın! 💁‍♀️",
      c: 'Çapraz Satış',
    },
    {
      m: 'Ocak',
      t: "🎉 Martin Luther Günü'nü Kutlayın 🇺🇸",
      d: 'Tüm siparişlerde 🔥 %55 İNDİRİM keyfini çıkarın!\n\nBugün en iyi ürünleri seçin! 💃',
      c: 'Satış Duyurusu',
    },
    {
      m: 'Ocak',
      t: "Hızlı olun, ⏳ kaçırmayın!",
      d: "Martin Luther Günü'nde Fırsatı Yakalayın! 🛍️\n\n🤩 %65'e Varan İndirim 🤩",
      c: 'Satış Duyurusu',
    },
    {
      m: 'Ocak',
      t: '1 Alana 1 Bedava 🤑',
      d: '🇺🇸 Martin Luther Günü’nü Özel Bir Teklifle Kutlayın! 🎉\n\n1 Alana 1 Bedava! Kodu Kullanın 👉 MARTIN22\n\nAceleyin, Sınırlı Süre! ',
      c: 'Sınırlı Süre Teklifi',
    },
    {
      m: 'Ocak',
      t: "🛒 Sepetinizdeki Ürünleri Kaçırmayın!",
      d: "\nSepetinizi Tamamlayarak %20'ye Varan İndirim 🤑 Kazanın! 24 Saat İçinde Tamamlayın ⏳\n\nMutlu Martin 🇺🇸 Luther Günü!",
      c: 'Terk Edilen Sepet',
    },
  ];

  return (
    <div>
      <LayeredDashboardHeader
        tab={tab}
        setIsActive={setIsActive}
        onLeave={() => setIsActive(false)}
      ></LayeredDashboardHeader>
      <div className="w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible">
        <div className="bg-[#f5f5f5] flex flex-col p-[20px] items-center pb-[20px] 2lx:pb-[40px] ">
          <div className="cursor-pointer flex justify-center flex-row flex-wrap w-[100%] border rounded-[10px] bg-white p-[45px] gap-[20px] overflow-x-auto">
            {data?.map((item, index) => (
              <div
                className="p-5 border rounded-[10px] p-[20px]"
                style={{
                  background: 'linear-gradient(0deg, #7059ef 0%, #e1d4ff 35%, #f0eefc 100%)',
                  width: 'max-content',
                }}
                onClick={() => {
                  setNotificationHeader(item?.t);
                  setNotificationDescription(item?.d);
                  setIsActive(false);
                }}
              >
                <div
                  className="w-[300px] flex-col border rounded-[10px] bg-white p-[10px] "
                  style={{ minHeight: 180, minWidth: 300, backgroundColor: '#dde2ed' }}
                >
                  <div className="flex items-center justify-between mb-[10px]">
                    <div className="flex align-center items-center gap-[5px]">
                      <img className="border rounded-[30%] w-[20px] h-[20px] bg-[#7059ef]" src={app?.appLogo}></img>
                      <div style={{ fontWeight: '500', fontSize: 12, color: '#585b60' }}>MESSAGES</div>
                    </div>

                    <div style={{ fontWeight: '500', fontSize: 12, color: '#585b60' }}>now</div>
                  </div>
                  <div style={{ fontWeight: '600', fontSize: 14 }}>{item.t}</div>
                  <div style={{ fontWeight: '500', fontSize: 13, marginTop: 10 }}>{item.d}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UseTemplate;
